import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading || user === null) {
    return (
      <div className="flex min-h-[60vh] items-center justify-center" data-testid="protected-route-loading">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-sovereign border-t-transparent" />
      </div>
    );
  }
  if (user === false) {
    return <Navigate to="/login" replace />;
  }
  return children;
};
